import Bacon from 'Bacon';
import $ from 'jquery';
import modal from 'modal';
import PropTypes from 'prop-types';
import {Component} from 'react';
import routing from 'routing';
import templates from 'template';

const templateStream = name => templates.get(name);

function mapPartials(names, partialTemplates) {
    const obj = {};
    names.forEach((name, i) => obj[name] = partialTemplates[i]);
    return obj;
}

function getPartialStream(partials) {
    return partials.length > 0 ? Bacon.combineAsArray(partials.map(templateStream)) : Bacon.constant(null);
}

const render = (partials, template, data) => template.render(data, partials);

const runPageScript = (name, request, scriptRouting) => {
    return Bacon.fromCallback(cb => require(['pages/' + name], cb))
        .onValue(script => script(request, scriptRouting));
};


const pageRequest = ({params}, pageChange) => ({
    pageChange,
    params,
    render(templateName, data, partials) {
        partials = Array.isArray(partials) ? partials : [];

        return getPartialStream(partials).flatMap(partialTemplates => {
            const renderPartials = (template, templateData) => render(mapPartials(partials, partialTemplates), template, templateData);
            const template = templates.get(templateName);
            return template
                .combine(Bacon.combineTemplate(data).take(1), renderPartials);
        });
    },
});

const hideHover = () => $('.hover-container').hide();

let initialPageLoad = true;

/**
 * This component mimics the old routing logic that the legacy pages need using React lifecycle callbacks.
 */
export default class LegacyPage extends Component {
    static propTypes = {
        page: PropTypes.string.isRequired,
        loadTemplate: PropTypes.func,
        leave: PropTypes.func,
        match: PropTypes.shape({
            path: PropTypes.string,
        }).isRequired,
    };

    lastPage = null;

    refresh() {
        const {page, loadTemplate, match} = this.props;

        const isPageChange = this.lastPage !== page;
        this.lastPage = page;

        const request = pageRequest(match, isPageChange);

        if (initialPageLoad) {
            initialPageLoad = false;
            runPageScript(page, request, routing);
            return;
        }

        hideHover();
        if (loadTemplate) {
            modal.close();

            const htmlStream = loadTemplate(request, routing);

            if (htmlStream) {
                const spaRoot = $('#content').find('#spa-root');
                htmlStream
                    .flatMap(html => html)
                    .doAction(() => spaRoot.nextAll().remove())
                    .onValue(html => {
                        spaRoot.after(html);
                        runPageScript(page, request, routing);
                    });
            }
        } else {
            runPageScript(page, request, routing);
        }
    }

    componentDidMount() {
        this.refresh(true);
    }

    componentDidUpdate() {
        this.refresh(false);
    }

    componentWillUnmount() {
        const {leave} = this.props;
        if (leave) {
            leave();
        }
    }

    render() {
        return null;
    }
}




// WEBPACK FOOTER //
// ./web/js/components/LegacyPage.js